import React, { Component } from "react";
import { FontAwesomeIcon }           from '@fortawesome/react-fontawesome'
import { Button, Modal, FormControl } from "react-bootstrap";
import { s3PublicGetImage }        from "../../libs/awsLib";
import AutoSuggestClientName      from "../../components/autosuggest/AutoSuggestClientName";
import "../../css/modal/ModalBasics.css";

export default class ModalProgressDetails extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showModalSimple: false,
            clientId: "",
        };
    }
    componentDidMount() {
        var photo_id     = this.props.photoId;

        if(photo_id != null)
            this.getPhotoURL(photo_id);

    }

    componentWillUnmount() {
        // Reset Input Values
        this.setState({
            program_name: "",
        });
    }

    getPhotoURL = async (photo_id) => {
        var url = await s3PublicGetImage("progress-photos", photo_id);

        this.setState({
            progressPhoto: url
        })
    }

    render() {
        var title        = this.props.title;
        var date_created = this.props.dateCreated;
        var notes        = this.props.notes;

        return (
            <Modal
                    show        = {this.props.show}
                    onHide      = {this.props.onHide}
                    className   = "modalBasics"
              >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title" className="fontSize26px">
                        <span className="glyphicon glyphicon-user sideNavBarIcon" style={{ fontSize: '1.2em' }}/>
                        <span className="modalBasicsTitle">
                             Progress Details: { this.props.clientName }
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="modalBasicsBody" style={{paddingLeft:45}}>
                          <div className="modalFormLabelBody">
                              { title }
                          </div>
                          <br/>
                          <div>
                              { /* }<div className="modalFormLabelBody">Photo:</div>*/}
                                  <img id="clientDetailProfilePhoto"
                                       src={this.state.progressPhoto}
                                       style={{position:"relative", top:"-10px",maxWidth:"250px", maxHeight:"250px"}}
                                   />

                          </div>
                          <br/>
                          <div>
                              <div className="modalFormLabelBody">Comments:</div>
                              <div>{notes}</div>
                          </div>
                          <br/>
                          <div>
                              Date: { date_created }
                          </div>
                          <br/>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="modalBasicsBtnClose" onClick={this.props.onHide}>Close</Button>
                    <span className="modalBasicsFooterXPosSpacer"/>
                </Modal.Footer>
              </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modal/ModalProgressDetails.js